import type { StackedCarouselSlideProps } from "react-stacked-center-carousel";

import { cn } from "$/lib/utils/functions/misc.functions";

export const StackedCarouselSlide = ({
  data,
  dataIndex,
  isCenterSlide,
}: StackedCarouselSlideProps) => {
  const item = data[dataIndex];

  if (!item) return <></>;

  const { cover } = item;

  return (
    <div
      className={cn("h-[400px] w-full select-none max-sm:h-[300px]", {
        "blur-sm": !isCenterSlide,
      })}
    >
      <img
        className="h-full w-full rounded-[40px] object-cover"
        draggable={false}
        src={cover}
      />
    </div>
  );
};
